module.exports = __webpack_public_path__ + "static/img/ftreport.969a1fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftreport.png
// module id = 3mFw
// module chunks = 0